
import { defineComponent, onMounted, ref, watch } from "vue";

import { Nullable, useResource } from "@tager/admin-services";
import {
  OptionType,
  FormField,
  FormFieldMultiSelect,
  FormFieldCheckbox,
} from "@tager/admin-ui";

import { FullFieldType } from "@/typings/model";
import { getField } from "@/services/requests";
import {
  FieldConditionFormValue,
  operatorOptionList,
} from "@/views/CategoryForm/CategoryForm.helpers";

type Props = Readonly<{
  fieldCondition: FieldConditionFormValue;
}>;

export default defineComponent({
  name: "FieldCondition",
  components: {
    FormField,
    FormFieldMultiSelect,
    FormFieldCheckbox,
  },
  props: {
    fieldCondition: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      required: true,
    },
  },

  setup(props) {
    const [
      fetchField,
      { data: fieldList, loading: isFieldListLoading, error },
    ] = useResource<Nullable<FullFieldType>>({
      fetchResource: () =>
        getField(
          props.fieldCondition.field ? props.fieldCondition.field.value : ""
        ),
      initialValue: null,
      resourceName: "Field list",
    });

    onMounted(() => {
      fetchField();
    });
    const fieldOption = ref<Array<OptionType<number>>>([]);
    watch(
      () => props.fieldCondition.field,
      () => {
        fetchField();
        props.fieldCondition.checkbox = false;
        props.fieldCondition.number = "0";
        props.fieldCondition.operator = null;
        props.fieldCondition.options = [];
      },
      { deep: true }
    );

    watch(fieldList, () => {
      if (!(fieldList && fieldList.value && fieldList.value?.options?.length))
        return;
      fieldOption.value = fieldList.value.options.map((option) => ({
        value: option.id,
        label: option.name,
      }));
    });

    return { fieldList, operatorOptionList, fieldOption };
  },
});
